RivalIQ.module('export.models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    const EmailedReport = models.EmailedReport = models.Report.extend({
        url: function () {
            const me = this;
            return `/api/landscapes/${me.get('landscapeId')}/report/email`;
        },
        exportSuccessMsg: 'We are busy creating your report. It should arrive in your inbox shortly.',
        exportErrorMsg: 'We had an issue exporting your report.  Please try again.',
        action: RivalIQ.export.type.EMAIL,

        // Do not download emailed reports
        download: function () {
            return null;
        },

        validate: function (attrs) {
            const errors = [];

            if (!_.exists(attrs.format)) {
                errors.push(['format', 'Please pick a filetype']);
            }

            if (!_.exists(attrs.email) || !attrs.email.length) {
                errors.push(['email', 'Please tell us where to send the report']);
            }

            return (errors.length ? errors : null);
        },

        initialize: function () {
            const me = this;

            models.Report.prototype.initialize.apply(me, arguments);
        }
    });

    EmailedReport.action = RivalIQ.export.type.EMAIL;
});
